// extracted by mini-css-extract-plugin
export var editorIframe = "VideoEmbed-module--editorIframe--ac933 VideoEmbed-module--iframe--fc2df";
export var editorWrapper = "VideoEmbed-module--editorWrapper--9ec30 VideoEmbed-module--wrapper--f6fea";
export var error = "VideoEmbed-module--error--79a3a";
export var iframe = "VideoEmbed-module--iframe--fc2df";
export var placeholder = "VideoEmbed-module--placeholder--a7c50";
export var wrapper = "VideoEmbed-module--wrapper--f6fea";